export function ProbeHistory() {
  return (
    <div className="bg-slate-900 border border-slate-800 rounded-xl">
      <div className="flex items-center justify-between px-5 py-4 border-b border-slate-800">
        <h3 className="text-sm font-semibold text-slate-300 uppercase tracking-wider">Probe History</h3>
      </div>
      <div className="flex flex-col items-center justify-center py-16 gap-3">
        <span className="text-4xl">🔍</span>
        <p className="text-slate-300 font-medium text-sm">Coming soon</p>
        <p className="text-slate-500 text-xs text-center max-w-xs">
          Geo probe history will be available once probing is enabled for your account.
        </p>
      </div>
    </div>
  );
}
